<script setup lang="ts">
import { Icon } from '@iconify/vue2'
import { onClickOutside } from '@vueuse/core'
import { ref } from 'vue'
import { ContextMenuStatusEnum } from './enums/ContextMenuStatus.enum'
import { ContextMenuOption } from './dtos/ContextMenuOption.dto'

const status = ref(ContextMenuStatusEnum.IDLE)
const optionsRef = ref()

withDefaults(
	defineProps<{
		options: ContextMenuOption[]
		icon?: string
		iconColor?: string
	}>(),
	{
		icon: 'mage:dots',
		iconColor: 'text-black-neutral',
	},
)

const emit = defineEmits<{
	(event: 'change', value: string): void
	(event: string): void
}>()

function handleChosenOption(event: string) {
	emit('change', event)
	emit(event)
	status.value = ContextMenuStatusEnum.CLOSED
}

onClickOutside(optionsRef, () => {
	if (status.value === ContextMenuStatusEnum.OPENED) {
		status.value = ContextMenuStatusEnum.CLOSED
	}
})
</script>

<template>
	<div
		style="display: flex"
		class="gap-2 relative"
	>
		<div @click="status = ContextMenuStatusEnum.OPENED">
			<Icon
				class="cursor-pointer"
				:class="[iconColor]"
				:icon="icon"
				width="1.2em"
				height="1.2em"
			/>
		</div>
		<ul
			ref="optionsRef"
			:class="status"
			class="list absolute bg-gray-light w-fit rounded-md min-w-max z-10 shadow-md left-8"
		>
			<li
				v-for="option in options"
				:key="option.event"
				class="flex gap-2 items-center px-4 py-1.5 first:rounded-t-md text-sm last:rounded-b-md hover:bg-blue-base hover:text-white-neutral cursor-pointer"
				@click="handleChosenOption(option.event)"
			>
				<Icon
					v-if="option.icon"
					class="text-sm"
					:icon="option.icon"
				/>
				<span>{{ option.name }}</span>
			</li>
		</ul>
	</div>
</template>

<style>
.opened.list {
	animation: pop_in 0.1s linear forwards;
}

.closed.list {
	animation: pop_out 0.1s linear forwards;
}

.idle.list {
	display: none;
}

@keyframes pop_in {
	from {
		transform: scale(0.1);
	}

	to {
		transform: scale(1);
	}
}

@keyframes pop_out {
	from {
		transform: scale(1);
	}

	to {
		transform: scale(0.1);
		display: none;
	}
}

.v-application ol,
.v-application ul {
	padding-left: 0 !important;
}
</style>
